import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { Formik, Field, Form as FormikForm, ErrorMessage } from 'formik';
import * as Yup from 'yup';

const mobileSchema = Yup.object().shape({
  mobile: Yup.string()
    .matches(/^[0-9]{10}$/, "Mobile number must be exactly 10 digits")
    .required("Mobile number is required"),
});

const MobileNumberModal = ({ show, handleClose, onSubmitMobile }) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Enter Mobile Number</Modal.Title>
      </Modal.Header>
      <Formik
        initialValues={{ mobile: '' }}
        validationSchema={mobileSchema}
        onSubmit={(values, { resetForm }) => {
          onSubmitMobile(values.mobile);
          resetForm();
          handleClose();
        }}
      >
        {({ errors, touched }) => (
          <FormikForm>
            <Modal.Body>
              <Form.Group controlId="mobile">
                <Form.Label>Mobile Number</Form.Label>
                <Field
                  name="mobile"
                  type="text"
                  className={`form-control ${
                    errors.mobile && touched.mobile ? 'is-invalid' : ''
                  }`}
                  placeholder="Enter 10-digit mobile number"
                  onInput={(e) => {
                    e.target.value = e.target.value
                      .replace(/\D/g, '') // Remove non-digits
                      .slice(0, 10); // Limit to 10 digits
                  }}
                />
                <ErrorMessage
                  name="mobile"
                  component="div"
                  className="invalid-feedback"
                />
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Cancel
              </Button>
              <Button variant="primary" type="submit">
                Submit
              </Button>
            </Modal.Footer>
          </FormikForm>
        )}
      </Formik>
    </Modal>
  );
};

export default MobileNumberModal;
